import React, { useState, useEffect } from 'react';
import axios from 'axios';

const App = () => {
  const [leaderboardData, setLeaderboardData] = useState({ run: [], ride: [] });
  const [loading, setLoading] = useState({ run: true, ride: true });
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [isManualUpdating, setIsManualUpdating] = useState(false);
  const [activeTab, setActiveTab] = useState('run');
  

  // Fungsi untuk memproses data
  const processData = (data, type) => {
    const allEntries = data.flatMap(item => item.data);

    const filteredData = allEntries.filter(entry => {
      if (type === 'run') {
        if (entry.name === "Fauzan") {
          return entry.bib.startsWith("003");
        }
        if (entry.name.toLowerCase().includes("fauzan")) {
          return false;
        }
      }
      return true;
    });

    return filteredData.sort((a, b) => parseFloat(b.distance) - parseFloat(a.distance));
  };

  // Fungsi untuk format waktu
  const formatDateTime = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} GMT+7`;
  };

  // Fungsi untuk fetch data
  const fetchData = async (isManual = false, type = 'run') => {
    try {
      if (isManual) {
        setIsManualUpdating(true);
      } else {
        setLoading(prev => ({ ...prev, [type]: true }));
      }
      
      const endpoint = type === 'run' 
        ? 'https://df31-202-179-191-226.ngrok-free.app/api/data'
        : 'https://df31-202-179-191-226.ngrok-free.app/api/ride-data';
      
      const response = await axios.get(endpoint, {
        headers: {
          'ngrok-skip-browser-warning': 'true',
        }
      });
      
      const processedData = processData(response.data, type);
      setLeaderboardData(prev => ({ ...prev, [type]: processedData }));
      setLastUpdated(new Date());
      setError(null);
    } catch (error) {
      setError(`Error fetching ${type} data: ` + error.message);
    } finally {
      if (isManual) {
        setIsManualUpdating(false);
      } else {
        setLoading(prev => ({ ...prev, [type]: false }));
      }
    }
  };

  // Handler untuk tombol update manual
  const handleManualUpdate = () => {
    fetchData(true, activeTab);
  };

  // Handler untuk ganti tab
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Jika data untuk tab ini belum pernah di-load, fetch data
    if (leaderboardData[tab].length === 0 && !loading[tab]) {
      fetchData(false, tab);
    }
  };

  // Fetch data pertama kali dan setup interval
  useEffect(() => {
    fetchData(false, 'run'); // Load data run pertama kali
    fetchData(false, 'ride'); // Juga load data ride
    
    const intervalId = setInterval(() => {
      fetchData(false, 'run');
      fetchData(false, 'ride');
    }, 900000);
    
    return () => clearInterval(intervalId);
  }, []);

  const isLoading = loading.run && loading.ride && 
                   leaderboardData.run.length === 0 && 
                   leaderboardData.ride.length === 0;
  
  if (isLoading) return (
    <div style={{
      backgroundImage: 'url(/bg.jpeg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <p style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        padding: '20px',
        borderRadius: '5px'
      }}>Loading initial data...</p>
    </div>
  );
  
  if (error) return (
    <div style={{
      backgroundImage: 'url(/bg.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <p style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        padding: '20px',
        borderRadius: '5px'
      }}>{error}</p>
    </div>
  );

  return (
    <div style={{ 
      backgroundImage: 'url(/bg.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '100vh',
      padding: '20px'
    }}>
      
      {/* Overlay untuk opacity 80% */}
      <div style={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        minHeight: 'calc(100vh - 40px)',
        padding: '20px',
        borderRadius: '10px'
      }}>
        {/* Tab Navigation */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '20px',
          gap: '10px'
        }}>
          <button
            onClick={() => handleTabChange('run')}
            style={{
              padding: '10px 20px',
              backgroundColor: activeTab === 'run' ? '#4CAF50' : '#e0e0e0',
              color: activeTab === 'run' ? 'white' : '#333',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Running Leaderboard
          </button>
          <button
            onClick={() => handleTabChange('ride')}
            style={{
              padding: '10px 20px',
              backgroundColor: activeTab === 'ride' ? '#4CAF50' : '#e0e0e0',
              color: activeTab === 'ride' ? 'white' : '#333',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Cycling Leaderboard
          </button>
        </div>

        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          marginBottom: '20px'
        }}>
          <img 
            src="/naruto.gif"
            alt="Sport animation" 
            style={{ 
              width: '50px', 
              height: '50px',
              borderRadius: '50%',
            }} 
          />
          <h1 id="responsive-title" style={{ 
            textAlign: 'center',
          }}>
            {activeTab === 'run' ? '🏃PGASINT RUNNER LEADERBOARD🏃' : '🚴PGASINT CYCLING LEADERBOARD🚴'}
          </h1>
          <img 
            src="/naruto.gif"
            alt="Sport animation" 
            style={{ 
              width: '50px', 
              height: '50px',
              borderRadius: '50%',
              padding:0,
            }} 
          />
        </div>
        
        <table style={{ 
          border: '1px solid #ddd', 
          borderCollapse: 'collapse',
          width: '100%',
          maxWidth: '800px',
          margin: '0 auto',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          backgroundColor: 'white'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#4CAF50', color: 'white' }}>
              <th style={{ padding: '12px', textAlign: 'center' }}>Name</th>
              <th style={{ padding: '12px', textAlign: 'center' }}>BIB Number</th>
              <th style={{ padding: '12px', textAlign: 'right' }}>Distance (km)</th>
            </tr>
          </thead>
          <tbody>
            {/* Baris statis untuk Mulyadi hanya muncul di tab run */}
            
            {leaderboardData[activeTab].map((entry, index) => (
              <tr 
                key={`${entry.bib}-${index}`} 
                style={{ 
                  borderBottom: '1px solid #ddd',
                  backgroundColor: index % 2 === 0 ? 'white' : '#f9f9f9'
                }}
              >
                <td style={{ padding: '12px', textAlign: 'center' }}>
                  {entry.name}
                  {/* Medali untuk Cycling Leaderboard */}
                  {activeTab === 'ride' && index === 0 && ' 🥇'}
                  {activeTab === 'ride' && index === 1 && ' 🥈'}
                  {activeTab === 'ride' && index === 2 && ' 🥉'}
                  {/* Medali untuk Running Leaderboard (kecuali posisi 1) */}
                  {activeTab === 'run' && index === 0 && ' 🥇'}
                  {activeTab === 'run' && index === 1 && ' 🥈'}
                  {activeTab === 'run' && index === 2 && ' 🥉'}
                </td>
                <td style={{ padding: '12px', textAlign: 'center' }}>{entry.bib}</td>
                <td style={{ padding: '12px', textAlign: 'right' }}>{parseFloat(entry.distance).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
          marginTop: '20px'
        }}>
          {lastUpdated && (
            <div style={{
              color: '#666',
              fontSize: '0.9em'
            }}>
              Last updated data: {formatDateTime(lastUpdated)} (per 15 mins)
            </div>
          )}
          
          <button 
            onClick={handleManualUpdate}
            disabled={isManualUpdating || loading[activeTab]}
            style={{
              padding: '8px 16px',
              backgroundColor: isManualUpdating || loading[activeTab] ? '#cccccc' : '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: isManualUpdating || loading[activeTab] ? 'not-allowed' : 'pointer',
              fontSize: '0.9em',
              transition: 'background-color 0.3s'
            }}
          >
            {isManualUpdating || loading[activeTab] ? 'Updating...' : 'Update Now'}
          </button>
        </div>

        {/* Footer Copyright */}
        <footer style={{
          marginTop: 'auto',
          textAlign: 'center',
          padding: '20px 0 10px',
          color: '#666',
          fontSize: '0.8em'
        }}>
          © {new Date().getFullYear()} PGASINT Sportalent developed with 🫶 by Regy for PGASINT.
        </footer>
      </div>
    </div>
  );
};


export default App;